export enum UserType {
    USER = 'USER', ADMIN = 'ADMIN'
}

export enum WaitlistDay {
    MONDAY = '0', TUESDAY = '1', WEDNESDAY = '2', THURSDAY = '3', FRIDAY = '4', MISC = '5'
}

export enum WaitlistDisplay {
    WEEK, DAY
}